const DollarSignIcon = ({ color }) => {
  return <div style={{ color }}>$</div>;
};

export default DollarSignIcon;
